import { Component } from '@angular/core';
import { NavController, ToastController, AlertController, ModalController } from 'ionic-angular';
import { Globals } from "../../globals";
import { DishServices } from "../dish/services";
import { IngredientsServices } from "../ingredients/services";
import { MenuServices } from "../menu/services";
import { ConfigurationServices } from "../configuration/services";
import { ReservationsServices } from "../reservation/services";
import { StaticsServices } from '../services/statics';
import { DashboardTutorialSlidePage } from '../help/tutorial-slider/dashboard-tutorial-slide/dashboard-tutorial-slide';
import { Platform } from 'ionic-angular';
import { DishListPage } from '../dish/dish-list/dish-list';
import { MenuListPage } from '../menu/menu-list/menu-list';
import { ReservationLoaderPage } from '../reservation/reservation-loader/reservation-loader';
import { LoginPage } from '../auth/login/login';
import { AngularFireAuth } from 'angularfire2/auth';
import { TranslateService } from '@ngx-translate/core';
import { PopupInfoPage } from '../components/popups/popup-info/popup-info';
import { NativeStorage } from '@ionic-native/native-storage';
import { AddonsTriggerVersionProPage } from '../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { OrdersServices } from '../kitchen/services';
import { TakeawayServices } from '../takeaway/services';
import { NotificationsServices } from '../services/notificationsServices';
import { TPVServices } from '../tpv/services';
import { HomeUserBlock } from './home-dashboard/home-user-block/home-user-block';
import { PopupNewAppsPage } from '../components/popups/popup-new-apps/popup-new-apps';
import { AnalyticsPage } from '../analytics/analytics';
import { OrdersCoServices } from '../orders/services';
import { CustomServices } from '../custom/services';
import { StockListPage } from '../stock/stock-list/stock-list';
import { CartasMenusListPage } from '../cartas-menus/cartas-menus-list/cartas-menus-list';
import { ArticlesListPage } from '../articles/articles-list/articles-list';
import { OdsViewPage } from '../ods/ods-view/ods-view';
import { TpvPanelPage } from '../tpv/tpv-panel/tpv-panel';
import { ArticlesCreateTypePage } from '../articles/articles-create/articles-create-type/articles-create-type';

@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})


export class HomePage {
    pi: number = 3.14;
    e: number = 2.718281828459045;
    today: number = Date.now();
    lang: string = 'es';

    constructor(public navCtrl: NavController,
        public globals: Globals,
        public dishServices: DishServices,
        public ingredientsServices: IngredientsServices,
        public menuServices: MenuServices,
        public configurationServices: ConfigurationServices,
        public reservationsServices: ReservationsServices,
        public staticsServices: StaticsServices,
        public plt: Platform,
        private toastCtrl: ToastController,
        public afAuth: AngularFireAuth,
        private alertCtrl: AlertController,
        public translate: TranslateService,
        public modalCtrl: ModalController,
        public nativeStorage: NativeStorage,
        public ordersServices: OrdersServices,
        public takeawayServices: TakeawayServices,
        public notificationsServices: NotificationsServices,
        public tpvServices: TPVServices,
        public ordersCoServices: OrdersCoServices,
        public customServices: CustomServices) {

        if (this.globals.user_disable) {
            this.navCtrl.push(HomeUserBlock);
        }
        //Si el restaurante quiere empezar por cartas, y no ha entrado aun en la seccion de cartas y menus
        if (this.globals.restaurant.register_start_by == 'Carta y menús' && this.globals.restaurant.plg_cartamenu_starter == undefined) {
            this.globals.side_menu_active = 'carta';
            this.navCtrl.setRoot(CartasMenusListPage);
            this.globals.side_menu_active_analytics = false;
            this.globals.open_side_menu = false;
        } else if (this.globals.restaurant.register_start_by == 'Reservas' && this.globals.restaurant.plg_reservas_starter == undefined) {
            this.globals.side_menu_active = 'reservation';
            this.navCtrl.setRoot(ReservationLoaderPage);
            this.globals.side_menu_active_analytics = false;
            this.globals.open_side_menu = false;
        } else if (this.globals.restaurant.register_start_by == 'Stock y escandallos' && this.globals.restaurant.plg_articles_starter == undefined) {
            this.globals.side_menu_active = 'dish';
            this.navCtrl.setRoot(ArticlesListPage).then(() => this.navCtrl.push(ArticlesCreateTypePage));
            this.globals.side_menu_active_analytics = false;
            this.globals.tourLaunchStep(1);
            this.globals.open_side_menu = false;
        } else if (this.globals.restaurant.register_start_by == 'Pedidos online' && this.globals.restaurant.plg_pedidos_starter == undefined) {
            this.globals.side_menu_active = 'web';
            this.navCtrl.setRoot(OdsViewPage);
            this.globals.side_menu_active_analytics = false;
            this.globals.open_side_menu = false;
        } else if (this.globals.restaurant.register_start_by == 'POS, Orders y KDS' && (this.globals.restaurant.plg_pos_starter == undefined && this.globals.restaurant.plg_orders_starter == undefined && this.globals.restaurant.plg_kds_starter == undefined)) {
            this.globals.side_menu_active = 'tpv';
            this.navCtrl.setRoot(TpvPanelPage, {
                origin: 'tpv'
            });
            this.globals.side_menu_active_analytics = false;
            this.globals.open_side_menu = false;
        }

        this.globals.side_menu_active = 'dashboard';

        // Los tags ya se cargan al inicio de la app en getAllTags()

        this.globals.checkBarTable();//IMPORTANTE cuando no hay table bar

        //Track Analytics
        //this.globals.GAsetUserId(this.globals.restaurant.email);
        this.globals.GAtrackView('Dashboard', 'Dashboard - view', this.globals.restaurant.email, 'View', 'View dashboard', 'Dashboard', '');
        this.globals.GAtrackView('User', this.globals.restaurant.email, this.globals.restaurant.email, 'View', 'View dashboard', 'Dashboard', '');

        this.globals.AdressApi(this.globals.restaurant.address, this.globals.restaurant_uid, 'home'); //Save Geo Restaurant

        this.ordersServices.print_hour = new Date();
    }

    async ionViewWillEnter() {
        if (this.globals.restaurant_uid == this.globals.arrosseria_uid) {
            this.searchArrosseriaTickets();
        }
    }

    async searchArrosseriaTickets() {
        this.customServices.searchArrosseriaTickets();
    }

    openAddons() {
        this.globals.side_menu_active = 'addons';
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }

    openTuto() {
        if (this.globals.side_menu_active == 'dashboard') {
            this.navCtrl.push(DashboardTutorialSlidePage);
        }
    }

    openOrders() {
        if (this.globals.checkLimitsByLicense('tpv', 'comandero')) {
            this.globals.mobile_is_room = true;
            this.globals.side_menu_active = 'order';
            this.navCtrl.push(PopupNewAppsPage, { app: 'order' });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    openTakeaway() {
        if (this.globals.checkLimitsByLicense('tpv', 'takeaway')) {
            this.globals.mobile_is_room = false;
            this.tpvServices.menu_select_room = 'take_away';
            this.globals.side_menu_active = 'tpv';
            this.navCtrl.push(PopupNewAppsPage, { app: 'pos' });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    openPrinterSunmi() {
        //abrir pagina con las nueva APP
        this.navCtrl.push(PopupNewAppsPage, { app: 'print' });
    }

    openDish() {
        this.globals.side_menu_active = 'dish';
        this.navCtrl.push(DishListPage);
    }
    openIngredients() {
        this.globals.side_menu_active = 'stock';
        this.navCtrl.push(StockListPage);
    }
    openMenus() {
        this.globals.side_menu_active = 'menu';
        this.navCtrl.push(MenuListPage);
    }
    openReservations() {
        if (this.globals.checkLimitsByLicense('reservations', 'calendar')) {
            this.globals.side_menu_active = 'reservation';
            this.navCtrl.push(ReservationLoaderPage);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    public openAnalytics() {
        this.globals.side_menu_active = 'informes';
        this.navCtrl.setRoot(AnalyticsPage);

    }

    logout() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-cerrar-sesion'),
            message: this.translate.instant('instant-seguro-quieres-cerrar-sesion'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.delNotTokenAndLogout();
                    }
                }
            ]
        });
        alert.present();
    }

    async delNotTokenAndLogout() {
        //funcion que borra token
        await this.configurationServices.deleteToken(this.globals.token_user_uid, this.globals.token_current_user);
        //hacemos logout de afAuth
        this.afAuth.auth.signOut()
            .then(authData => {
                // toast message
                let toast = this.toastCtrl.create({
                    message: this.translate.instant('instant-cerrado-sesion'),
                    duration: 3000,
                    position: 'top'
                });
                toast.present();
                if (this.globals.user_type != 'principal' && this.globals.user_type != 'teacher') {
                    this.globals.GAtrackView('Logout', 'Logout ', this.globals.restaurant.email, 'Logout', 'Logout', 'Logout', '');
                }

                this.navCtrl.setRoot(LoginPage);
                window.location.reload();
            }, error => {
                //var errorMessage: string = error.message;
            });
    }

    changeNetworkState(state) {
        this.globals.connection_manual = state;

        if (this.globals.connection_manual) {
            this.openOfflineInfo();
            this.globals.connection = false;
            this.nativeStorage.getItem('offline_number')
                .then(
                    data => { },
                    error => {
                        //no tiene crear
                        this.nativeStorage.setItem('offline_number', 0)
                            .then(() => { }, error => { });
                    }
                );
        } else {
            this.globals.connection = true;
        }
    }

    openOfflineInfo() {
        let profileModal = this.modalCtrl.create(PopupInfoPage, { origin: 'offline' });
        profileModal.onDidDismiss(data => {
        });
        profileModal.present();
    }

    openApp(app) {
        switch (app) {
            case 'all':
                if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
                    this.openLinkApp('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
                } else {
                    this.openLinkApp('https://play.google.com/store/apps/developer?id=MyChefTool');
                }
                break;
            case 'print':
                if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
                    this.openLinkApp('https://apps.apple.com/es/app/mct-print/id1624692351');
                } else {
                    this.openLinkApp('https://play.google.com/store/apps/details?id=com.mycheftool.printer');
                }
                break;
            case 'kds':
                if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
                    this.openLinkApp('https://apps.apple.com/es/app/mct-kitchen-display-system/id1625644596');
                } else {
                    this.openLinkApp('https://play.google.com/store/apps/details?id=com.mycheftool.kds');
                }
                break;
            case 'order':
                if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
                    this.openLinkApp('https://apps.apple.com/es/app/mct-order/id1626244345');
                } else {
                    this.openLinkApp('https://play.google.com/store/apps/details?id=com.mycheftool.orders');
                }
                break;
            case 'pos':
                if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
                    this.openLinkApp('https://apps.apple.com/es/app/mct-pos/id1628506564');
                } else {
                    this.openLinkApp('https://play.google.com/store/apps/details?id=com.mycheftool.tpv');
                }
                break;
            default:
                if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
                    this.openLinkApp('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
                } else {
                    this.openLinkApp('https://play.google.com/store/apps/developer?id=MyChefTool');
                }
                break;
        }
    }

    openLinkApp(url) {
        if (this.globals.so_mobile) {
            window.location.assign(url);
        } else {
            window.open(url, '_blank');
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts